import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const useStyles = makeStyles(() => ({
  styledLink: {
    backgroundColor: 'var(--dai-color-surface4)',
    borderRadius: 'var(--border-radius-md)',
    border: 'var(--dai-border1)',
    paddingLeft: 'var(--padding-sm)',
    paddingRight: 'var(--padding-sm)',
    boxShadow: 'var(--shadow-sm)',
    whiteSpace: 'nowrap',
    transition: 'background-color var(--transition-duration-short) var(--transition-easing-normal)',
    '&:hover': {
      backgroundColor: 'var(--dai-color-bg-inline)'
    }
  }
}))

function StyledLink ({ href, title, newTab, className, children }) {
  const classes = useStyles()

  return (
    <a
      className={clsx(className, classes.styledLink)}
      href={href}
      title={title}
      target={newTab ? '_blank' : undefined}
      rel='noopener noreferrer'
    >
      {children}
    </a>
  )
}

StyledLink.propTypes = {
  href: PropTypes.string,
  title: PropTypes.string,
  newTab: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node
}

export default StyledLink
